<agr-form-dialog
  class="production-settings"
  [formGroup]="formGroup"
  (confirm)="update()"
  (alt)="alt()"
  (cancel)="cancel()"
  [data]="data"
>
  <div class="wrapper--spacing-vertical content">
    @if (attentionLimits) {
      <div class="spacing--margin-bottom">
        <agr-summary-card
          [title]="
            'dairyresults.individual-production.settings.title-settings-within-period' | translate
          "
        >
          <div class="flex--column">
            <div class="production-settings__content--description">
              <p class="text--bold">
                {{ 'dairyresults.individual-production.settings.attention-validity' | translate }}
              </p>
            </div>
          </div>
          <div class="flex--column">
            <mat-form-field>
              <mat-label>{{
                'dairyresults.individual-production.settings.from-lactation-days' | translate
              }}</mat-label>
              <input matInput agrNumber [step]="1" formControlName="fromLactationDays" />
            </mat-form-field>
          </div>
          <div class="flex--column">
            <mat-form-field>
              <mat-label>{{
                'dairyresults.individual-production.settings.to-lactation-days' | translate
              }}</mat-label>
              <input matInput agrNumber [step]="1" formControlName="toLactationDays" />
            </mat-form-field>
          </div>
          <div class="flex--column">
            <div class="production-settings__content--description">
              <p class="text--bold">
                {{ 'dairyresults.individual-production.settings.attention-limits' | translate }}
              </p>
            </div>
          </div>
          <div class="flex--column">
            <mat-form-field>
              <mat-label>{{
                'dairyresults.individual-production.settings.minimum-fat-percentage' | translate
              }}</mat-label>
              <input matInput agrNumber [step]="0.01" formControlName="minimumFatPercentage" />
            </mat-form-field>
          </div>
          <div class="flex--column">
            <mat-form-field>
              <mat-label>{{
                'dairyresults.individual-production.settings.minimum-protein-percentage' | translate
              }}</mat-label>
              <input matInput agrNumber [step]="0.01" formControlName="minimumProteinPercentage" />
            </mat-form-field>
          </div>
          <div class="flex--column">
            <mat-form-field>
              <mat-label>{{
                'dairyresults.individual-production.settings.maximum-fat-protein-percentage'
                  | translate
              }}</mat-label>
              <input
                matInput
                agrNumber
                [step]="0.01"
                formControlName="maximumFatProteinPercentage"
              />
            </mat-form-field>
          </div>
          <div class="flex--column">
            <mat-form-field>
              <mat-label>{{
                'dairyresults.individual-production.settings.when-minimum-protein-percentage'
                  | translate
              }}</mat-label>
              <input
                matInput
                agrNumber
                [step]="0.01"
                formControlName="whenMinimumProteinPercentage"
              />
            </mat-form-field>
          </div>
          <div class="flex--column">
            <mat-form-field>
              <mat-label>{{
                'dairyresults.individual-production.settings.decrease-percentage-kg-milk'
                  | translate
              }}</mat-label>
              <input matInput agrNumber [step]="0.01" formControlName="decreasePercentageKgMilk" />
            </mat-form-field>
          </div>
          <div class="flex--column">
            <mat-slide-toggle
              [hideIcon]="true"
              color="primary"
              formControlName="fatPercentageLowerThenProteinPercentage"
            >
              {{
                'dairyresults.individual-production.settings.fat-percentage-lower-then-protein-percentage'
                  | translate
              }}
            </mat-slide-toggle>
          </div>
        </agr-summary-card>
        <agr-summary-card
          [title]="'dairyresults.individual-production.settings.title-settings' | translate"
        >
          <div class="production-settings__content--description">
            <p class="text--bold">
              {{ 'dairyresults.individual-production.settings.somatic-cell-count' | translate }}
            </p>
          </div>
          <div class="flex--column">
            <mat-form-field>
              <mat-label>{{
                'dairyresults.individual-production.settings.max-somatic-cell-count-cow' | translate
              }}</mat-label>
              <input matInput agrNumber [step]="1" formControlName="maxSomaticCellCountCow" />
            </mat-form-field>
          </div>
          <div class="flex--column">
            <mat-form-field>
              <mat-label>{{
                'dairyresults.individual-production.settings.max-somatic-cell-count-heiver'
                  | translate
              }}</mat-label>
              <input matInput agrNumber [step]="1" formControlName="maxSomaticCellCountHeifer" />
            </mat-form-field>
          </div>
        </agr-summary-card>
      </div>
    }
  </div>
</agr-form-dialog>
